import { Checkbox, FormControlLabel } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './Checkbox.scss';

interface AppCheckboxProps {
  label: string;
  checked?: boolean;
  defaultChecked?: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
}

const AppCheckbox: FC<AppCheckboxProps> = ({
  label,
  checked,
  defaultChecked,
  indeterminate,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <FormControlLabel
      className="AppCheckbox"
      control={
        <Checkbox
          size="large"
          checked={!!checked}
          defaultChecked={defaultChecked}
          indeterminate={indeterminate}
          onChange={onChange}
          disableRipple
          disabled={disabled}
        />
      }
      label={t(label)}
    />
  );
};

export default AppCheckbox;
